// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2020-03-10T18:04:13+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  65008
//    Project:        222
//    Environment:    465 - master
//    MD5:            de483289aa634f06e57725b6f29334bf
//    Signature:      eyJpdiI6IjlNVGo1V3psOGNJSVhqeGx0TDBnYWc9PSIsInZhbHVlIjoiVWxlZ0RVZWtqUXJLaWNVeVk4WmYyMjlcL2phd25UZlhXOHA2cHgydlFXendJMnBXZHhyUkRsdTJLbllaWmVvOE9sSkpOZ0Z0T1FUU1Zab1hWNW9LemhZMnNOcEt2dFlZUSsrcUVFcTVodnc4d1drUXRESGNVS2QrSVJrUFJHakZHYnh3YmhcL0k1NWZUSDdWOVNYcUpsZEJjakdPbHdZakJFY2xmcWhMWHBvdmVoUEl1TitoeFM2Vml1T1dBdm9hbzRmY1wvOUR0UjlyWWg3R3VMNEVMaVhVd3V5ZktrRGlVbjFVanRya3Y0d0ZWZTc1OTZtSmdPRFVHYjJjSGlvRm1HVE5lVURkS05vdDJScjVmXC9kZUwxbzlJWVQyWWxXUGlIN1JIajg3ZXQ4a0Y5NlU3YmF0TTdxQUxQVGZWMnNGQ01Id1N5cnNvS1pFNm1uUG82TW9uUE1JMU1KcDkwVUFSc282dDRSbit5emJyQ0N3bjMydUtPeXJiTW5PRVpPa2FKc0RsenNuVWJ2Umo1U3NNczA4bUJ5YWc9PSIsIm1hYyI6Ijk5MjE1OGVjMGRkNWIxODVkYzc5YmY2MTk1YjI1YzU3MTQ4M2ZkMjgwNjRkNGQ3MmNjNDBlNTFlNTg2YmNhZjQifQ==
$(document).ready(main);

function main() {

    var escTestiSlider = {};

    escTestiSlider.testimonialHolder = $('#testimonials-wrapper');
    escTestiSlider.testimonialSlides = escTestiSlider.testimonialHolder.find('.testimonial-slides');
    escTestiSlider.slideToMove = escTestiSlider.testimonialSlides.find('div:first-child');
    escTestiSlider.noOfSlides = escTestiSlider.testimonialSlides.find('div').length;
    escTestiSlider.testimonialSelect = escTestiSlider.testimonialHolder.find('.testimonial-select');
    escTestiSlider.testimonialSelects = escTestiSlider.testimonialSelect.find('li');
    escTestiSlider.currentClass = 'current';
    escTestiSlider.testimonialCurrentSelect = escTestiSlider.testimonialSelect.find('.' + escTestiSlider.currentClass);
    escTestiSlider.testimonialButtons = escTestiSlider.testimonialHolder.find('span.btn');
    escTestiSlider.baseMove = 100;
    escTestiSlider.moveSlides = 0;

    escTestiSlider.testimonialSelects.click(function() {

        escTestiSlider.selectedSlide = $(this);
        escTestiSlider.selectedSlideID = escTestiSlider.selectedSlide.attr('id');
        escTestiSlider.selectedSlideID = escTestiSlider.selectedSlideID.match(/[0-9]/)[0];
        escTestiSlider.selectedSlideID = parseInt(escTestiSlider.selectedSlideID);
        escTestiSlider.moveSlides = -(escTestiSlider.baseMove * escTestiSlider.selectedSlideID);

        moveSlides(escTestiSlider.slideToMove, escTestiSlider.moveSlides);

    });

    escTestiSlider.testimonialButtons.click(function() {

        escTestiSlider.clickedBtn = $(this);
        escTestiSlider.clickedBtn = escTestiSlider.clickedBtn.attr('class');
        escTestiSlider.clickedBtn = escTestiSlider.clickedBtn.match(/-([\w-]*\b)/)[1];

        switch (escTestiSlider.clickedBtn) {

            case "prev" :

                if (escTestiSlider.moveSlides === 0) return;

                escTestiSlider.moveSlides = escTestiSlider.moveSlides + escTestiSlider.baseMove;
                escTestiSlider.selectedSlide = escTestiSlider.testimonialCurrentSelect.prev();

            break;

            case "next" :

                var stopMoveTest = -(escTestiSlider.noOfSlides - 1) * escTestiSlider.baseMove === escTestiSlider.moveSlides;

                if (stopMoveTest) return;

                escTestiSlider.moveSlides = escTestiSlider.moveSlides - escTestiSlider.baseMove;
                escTestiSlider.selectedSlide = escTestiSlider.testimonialCurrentSelect.next();

            break;

        }

        moveSlides(escTestiSlider.slideToMove, escTestiSlider.moveSlides);

    });

    function moveSlides(slideToMove, moveTo) {

        slideToMove.css( { marginLeft : moveTo + "%" } );

        switchCurrentSelect(escTestiSlider);

    }

    function switchCurrentSelect(escTestiSlider) {

        var removeCurrent = escTestiSlider.testimonialCurrentSelect,
            addCurrent = escTestiSlider.selectedSlide,
            className = escTestiSlider.currentClass;

        removeCurrent.removeClass(className);
        addCurrent.addClass(className);

        escTestiSlider.testimonialCurrentSelect = addCurrent;

    }

}
